module.exports = __webpack_public_path__ + "img/9.2a40da29.png";